module.exports = "<div class=\"block-ui-template\">\r\n    <div class=\"lds-css\">\r\n        <div class=\"lds-wave\" style=\"width:100%;height:100%\">\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n        </div>\r\n    </div>\r\n    <div class=\"loadingMessage\"><strong>{{message}}</strong></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/block-template/block-template.component.html
// module id = ./src/app/shared/components/block-template/block-template.component.html
// module chunks = main